import { useEffect, useRef, useState } from "react";
import Tabs from "./Tabs";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { resetOffCanvasView, updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import FaMicrophone from "@/components/SVG/Fontawesome/FaMicrophone";
import { getUUID } from "@/utils/auth";
import { getMatches } from "@/helpers/api/service/ask";

const VoiceSearch = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState<string>("");
  const [isFinalText, setIsFinalText] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const recognitionRef = useRef<any>();

  const search = async () => {
    if (!searchText) return;
    const { data } = await getMatches(getUUID(), undefined, undefined, searchText);
    if (!data) return;
    dispatch(updateOffCanvasViewPayload({
      CAMERA: {
        text: searchText,
        questionId: data.question_id,
        matchedQuestions: data.matched_questions ?? [],
      },
    }));
  }

  useEffect(() => {
    if (!isFinalText) return;
    search();
  }, [isFinalText]);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition || window.oSpeechRecognition;
    if (!SpeechRecognition) {
      return;
    }
    recognitionRef.current = new SpeechRecognition();
    recognitionRef.current.interimResults = true;

    recognitionRef.current.onresult = (event: any) => {
      setSearchText(event.results[0][0].transcript);
      setIsFinalText(event.results[0].isFinal);
    }
    recognitionRef.current.onerror = ((e: any) => {
      setError(true);
    });
    recognitionRef.current.start();

    return () => {
      recognitionRef.current?.stop();
    }
  }, []);

  return (
    <>
      <div className="w-full grow flex flex-col justify-center items-center px-8 py-12 bg-secondary-light">
        <div className="relative flex justify-center items-center aspect-square h-40 w-40">
          <circle className="h-32 w-32 bg-accent animate-pingShort absolute opacity-20 rounded-full flex justify-center items-center"></circle>
          <circle className="h-28 w-28 bg-accent animate-pingShort absolute opacity-70 rounded-full flex justify-center items-center"></circle>
          <circle className="h-24 w-24 bg-accent absolute rounded-full flex justify-center items-center">
            <FaMicrophone className="text-4xl text-white rounded-full" />
          </circle>
          {error && <div className="absolute-center h-40 w-40 z-10 bg-white flex justify-center items-center text-center">Microphone is blocked please allow in settings</div>}
        </div>
        {/* TODO: once extracted to redux offCanvas it will be optimized and VoiceSearchTranscript component to be used */}
        <span className="text-base font-normal">{searchText}</span>
      </div>
      <div className="bg-black flex flex-col py-2">
        <Tabs />
        <div className="flex w-full h-32 justify-center items-center">
        </div>
      </div>
    </>
  );
}

export default VoiceSearch;